module.exports = __webpack_public_path__ + "img/02-defaul.e80eb0f8.png";